var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DefaultWidget", {
    attrs: {
      disabled: _vm.disabled || _vm.downloading,
      name: _vm.progress || "下载音频",
      icon: "mdi-download",
    },
    on: {
      click: function ($event) {
        return _vm.download()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }